export const WISHLIST_ID = 119199849;

export interface WishlistItem {
    /** Наш ID */
    id: string;
    /** Скрыт из избранного */
    hidden: boolean;
    /** Последнее обновление */
    syncedOn: number;
    /** Цена на момент добавления товара в избранное */
    pricedropPrice?: number;
    /** Уведомлять при понижении цены? Мы не уведомляем */
    notify?: { pricedrop: boolean };
}
